import { Trans } from '@lingui/react/macro'
import { useCompanyCustomers } from '$src/lib/hooks/useCompanyCustomers'
import {
  Card,
  Group,
  Stack,
  Text,
  ThemeIcon,
  UnstyledButton,
} from '@mantine/core'
import { IconBuilding, IconChevronRight } from '@tabler/icons-react'
import { useNavigate } from '@tanstack/react-router'

// Self-contained: only renders for users who are members of a company / housing company.
export function BusinessPortalCard() {
  const navigate = useNavigate()
  const { companies } = useCompanyCustomers()

  if (!companies.length) return null

  return (
    <Card radius="lg" withBorder shadow="xs" p="md">
      <Stack gap="sm">
        <Text size="md" fw={600}>
          <Trans>Business accounts</Trans>
        </Text>
        <Stack gap="xs">
          {companies.map((c) => (
            <UnstyledButton
              key={c.id}
              onClick={() => navigate({ to: `/company-portal/${c.id}` })}
            >
              <Group justify="space-between" wrap="nowrap">
                <Group gap="sm" wrap="nowrap">
                  <ThemeIcon
                    variant="light"
                    color="brandOrange"
                    radius="md"
                    size="md"
                  >
                    <IconBuilding size={16} />
                  </ThemeIcon>
                  <Text size="sm" fw={500} lineClamp={1}>
                    {c.name}
                  </Text>
                </Group>
                <IconChevronRight
                  size={16}
                  color="var(--mantine-color-gray-5)"
                />
              </Group>
            </UnstyledButton>
          ))}
        </Stack>
      </Stack>
    </Card>
  )
}
